import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import "react-datepicker/dist/react-datepicker.css";
import Check from "@mui/icons-material/Check";
import FormControl from "@mui/material/FormControl";
import { countryCode } from "../Components/CountryCode";
import { apiHeader, firebaseVapidObject, URL, validateEmail } from "../Config/apiUrl";
import { FormProvider } from "react-hook-form";
import LocationInput from "../Components/LocationInput";

import Button from "@restart/ui/esm/Button";
import TextField from "@mui/material/TextField";
import { useHistory } from "react-router";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Col, Container, Dropdown, Form, Image, Row } from "react-bootstrap";
import upload_icon from "../assets/images/upload_icon.png";
import blue_tick from "../assets/images/blue_tick.png";
import green_tick from "../assets/images/green_tick.png";
import Select1 from "react-select";
import { makeStyles } from "@mui/styles";
import { Get, Post } from "../Axios/AxiosFunctions";
import { Link } from "react-router-dom";
import {
  QontoConnector,
  BootstrapInput,
  QontoStepIconRoot,
} from "../Components/StepperStuff";
import CompanySignup from "../Components/CompanySignup";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { saveLoginUserData } from "../store/Actions/authAction";
import firebase, { messaging } from "../firebase";

var formData = new FormData();
const ProfileStepForm = ({ setfooterStyle }) => {
  const [myFCMToken, setMyFCMToken] = useState("");
  // If firebase supported, take out token and send to server
  useEffect(() => {
    const getToken = async () => {
      let token = "";
      if (firebase.messaging.isSupported()) {
        token = await messaging.getToken(firebaseVapidObject);
        setMyFCMToken(token);
      }
    };

    getToken();
  }, []);

  const dispatch = useDispatch();
  const history = useHistory();

  history.location.pathname ? setfooterStyle(true) : setfooterStyle(false);
  const [activeStep, setActiveStep] = useState(0);
  const [activeForm, setActiveForm] = useState(0);
  const [responseData, setResponseData] = useState([]);
  const [skills, setSkills] = useState([]);
  const [certificate, setCertificate] = useState([]);
  const [skillsField, setSkillsField] = useState([]);
  const [educationField, setEducationField] = useState([]);
  const [courseField, setCourseField] = useState([]);
  const [certificatesField, setCertificatesField] = useState([]);
  const [experienceField, setExperienceField] = useState([]);
  const [course, setCourse] = useState([]);
  const [education, setEducation] = useState([]);
  const [experience, setExperience] = useState([]);
  const [image1, setImage1] = React.useState("");
  const [image2, setImage2] = React.useState("");

  const [skillArray, setSkillArray] = useState([]);
  const [educationFieldArray, setEducationFieldArray] = useState([]);
  const [courseFieldArray, setCourseFieldArray] = useState([]);
  const [certificatesFieldArray, setCertificatesFieldArray] = useState([]);
  const [experienceFieldArray, setExperienceFieldArray] = useState([]);
  const [coursesNewArray, setCoursesNewArray] = useState([]);
  const [educationNewArray, setEducationNewArray] = useState([]);
  const [experienceNewArray, setExperienceNewArray] = useState([]);
  const [step2Form, setStep2Form] = useState({
    _skills: [],
    _education: "",
    _course: "",
    _certificate: "",
    _experience: [], //array
    _school: "",
  });

  const [craftmenData, setCraftmenData] = useState({
    userName: "",
    email: "",
    confirmEmail: "",
    countryCode: "",
    school: "",
    contactNo: "",
    password: "",
    passwordConfirm: "",
    description: "",
    lat: 12.2,
    lng: 3.21,
  });
  const [countryFlag, setCountryFlag] = useState("");

  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");

  const [step1Params, setStep1Params] = useState({});

  const [companyData, setCompanyData] = useState({
    role: "company",
    email: "",
    password: "",
    passwordConfirm: "",
    companyName: "",
    cvrNo: "",
    contactPerson: "",
    contactNo: "",
    description: "",
  });

  const [isApiCall, setIsApiCall] = useState(false);

  function QontoStepIcon(props) {
    const { active, completed, className, icon } = props;

    return (
      <QontoStepIconRoot ownerState={{ active }} className={className}>
        {completed ? (
          <Check className="QontoStepIcon-completedIcon" />
        ) : (
          <div className="QontoStepIcon-circle">{icon}</div>
        )}
      </QontoStepIconRoot>
    );
  }

  QontoStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
  };

  const steps = ["Select campaign settings", "Create an ad group", ""];

  // handleSubmitCompany
  const handleSubmitCompany = async (e, addressObj, city, image) => {
    e.preventDefault();
    const params = {
      role: companyData?.role,
      email: companyData?.email,
      companyName: companyData.companyName,
      address: addressObj?.formatted_address,
      password: companyData?.password,
      cvrNo: companyData.cvrNo,
      contactNo: companyData.contactNo,
      countryCode: companyData.countryCode,
      contactPerson: companyData.contactPerson,
      description: companyData.description,
      lat: addressObj?.geometry?.location?.lat(),
      lng: addressObj?.geometry?.location?.lng(),
      passwordConfirm: companyData?.passwordConfirm,
      city: city,
    };

    // no field can be empty
    for (let key in params) {
      if (
        params[key] == "" ||
        params[key] == null ||
        params[key] == undefined
      ) {
        return toast.warn(
          `${key.replace(/([a-z])([A-Z])/g, "$1 $2")} can not be empty.`
        );
      }
    }

    // image can not be empty
    if (!image) {
      return toast.warn("Please select an image.");
    }

    // validate email
    if (!validateEmail(companyData?.email)) {
      return toast.warn("Please enter a valid email address");
    }

    // validate email
    if (companyData?.password !== companyData?.passwordConfirm) {
      return toast.warn("Password should match with confirm password.");
    }

    // create formDatra
    const formData = new FormData();
    for (let key in params) {
      formData.append(key, params[key]);
    }

    // attach image
    formData.append("photo", image);
    // attach fcmToken
    formData.append("fcmToken", myFCMToken);

    // API
    const url = URL("general/signup");
    setIsApiCall(true);
    const response = await Post(url, formData, apiHeader(false, true));
    setIsApiCall(false);

    if (response !== undefined) {
      dispatch(saveLoginUserData(response?.data?.data));
      history.replace("/dashboard");
    }
  };

  const getdataSkills = URL(`admin/get-all-array`);

  const getSkills = async () => {
    const response = await Get(getdataSkills);

    setResponseData(response?.data?.data);
    setSkills(response?.data?.data?.skills);
    setCertificate(response?.data?.data?.certificates);
    setCourse(response?.data?.data?.courses);
    setEducation(response?.data?.data?.educations);
    setExperience(response?.data?.data?.experience);
    const newCourses = [];
    const newEducation = [];
    const newExperience = [];

    response?.data?.data?.courses.map((t) => {
      newCourses.push({ courses: t });
    });
    response?.data?.data?.educations.map((t) => {
      newEducation.push({ educations: t });
    });
    response?.data?.data?.experience.map((t) => {
      newExperience.push({ experience: t });
    });

    setCoursesNewArray(newCourses);
    setEducationNewArray(newEducation);
    setExperienceNewArray(newExperience);
  };

  useEffect(() => {
    getSkills();
  }, []);

  // geocoding
  useEffect(() => {
    if (address !== "") {
      var city = "";
      for (var i = 0, len = address.address_components.length; i < len; i++) {
        var ac = address.address_components[i];
        if (ac.types.indexOf("locality") >= 0) city = ac.long_name;
      }

      //only report if we got Good Stuff
      if (city != "") {
        setCity(city);
      }
    }
  }, [address]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == "countryCode") {
      let flag = countryCode.find((t) => t?.dial_code == value);
      flag = flag?.code?.toLowerCase();
      setCountryFlag(flag);
    }

    setCraftmenData({ ...craftmenData, [name]: value });
  };
  const handleChangeCompany = (e) => {
    const { name, value } = e.target;

    setCompanyData({ ...companyData, [name]: value });
  };
  const createFormdata = async (data) => {
    var formData = new FormData();
    formData.append("email", data?.email);
    formData.append("userName", data?.userName);
    formData.append("photo", data?.photo);
    formData.append("role", data?.role);
    formData.append("phoneNumber", data?.phoneNumber);
    formData.append("password", data?.password);
    formData.append("passwordConfirm", data?.passwordConfirm);
    formData.append("description", data?.description);
    formData.append("cv", data?.cv);
    formData.append("countryCode", data?.countryCode);
    formData.append("confirmEmail", data?.confirmEmail);

    // skillArray.forEach(function (element) {
    //   formData.append('skill', element);
    // })

    return formData;
  };
  const postCraftmenData = URL(`general/signup`);

  const handleSubmitCraftmen = async (e) => {
    e.preventDefault();
    if (craftmenData.password === craftmenData.passwordConfirm) {
      alert("Hello! I am an alert box!!");
    }

    const data = {
      ...craftmenData,
      skills: skillArray,
      education: educationField.educations,
      course: courseField.courses,
      certificates: certificatesFieldArray,
      experience: experienceField.experience,
      photo: image1,
      cv: image2,
      role: "user",
    };
    let formData = await createFormdata(data);
    Promise.all(formData).then((v) => (formData = v));

    const response = await Post(postCraftmenData, data);
  };

  // step form
  const handleNext = async (e) => {
    let params = {};
    // step == 1
    if (activeStep == 0) {
      params.role = "user";
      params.userName = craftmenData.userName;
      params.email = craftmenData.email;
      params.countryCode = craftmenData.countryCode;
      params.contactNo = craftmenData.contactNo;
      params.password = craftmenData.password;
      params.passwordConfirm = craftmenData.passwordConfirm;

      // vclidate
      for (let key in params) {
        if (params[key] == "") {
          return toast.warn(
            `${key.replace(/([a-z])([A-Z])/g, "$1 $2")} can not be empty.`
          );
        }
      }

      // validate email
      if (!validateEmail(craftmenData?.email)) {
        return toast.warn("Please enter a valid email address");
      }

      // validate email == confirm email
      if (craftmenData?.email !== craftmenData?.confirmEmail) {
        return toast.warn("Email should match with confirm email.");
      }

      // validate email
      if (craftmenData?.password !== craftmenData?.passwordConfirm) {
        return toast.warn("Password should match with confirm password.");
      }

      // put to form => update: see step 3
      // for (let key in params) {
      //   formData.append(key, params[key]);
      // }
      setStep1Params(params);

      setActiveStep(activeStep + 1);
    }

    // step == 1
    if (activeStep == 1) {
      const _skills = skillsField.map((e) => e?.skill);
      const _education = educationField?.educations;
      const _course = courseField?.courses;
      const _certificate = certificatesField.map((e) => e?.jobCertificate);
      const _experience = experienceField?.experience;

      // validate _skills
      if (_skills.length == 0) {
        return toast.warn("Please select atleast 1 skill.");
      }

      // validate _education
      if (!_education || _education == "") {
        return toast.warn("Please select education.");
      }

      // validate _course
      if (!_course || _course == "") {
        return toast.warn("Please select course.");
      }

      // validate _certificate
      if (!_certificate || _certificate == "") {
        return toast.warn("Please select atleast 1 certificate.");
      }

      // validate _certificate
      if (_certificate.length == 0) {
        return toast.warn("Please select atleast 1 certificate.");
      }

      // validate _experience
      if (!_experience || _experience == "") {
        return toast.warn("Please select atleast 1 experience.");
      }

      // validate craftmenData.school
      if (!craftmenData.school || craftmenData.school == "") {
        return toast.warn("School, can not be empty.");
      }

      // put to form
      setStep2Form({
        _skills, // array
        _education,
        _course,
        _certificate,
        _experience, //array
        _school: craftmenData.school,
      });
      // _skills.forEach((e) => formData.append("skills", e));
      // formData.append("education", _education);
      // formData.append("course", _course);
      // _certificate.forEach((e) => formData.append("certificates", e));
      // formData.append("experience", _experience);
      // formData.append("school", craftmenData.school);

      setActiveStep(activeStep + 1);
    }

    if (activeStep == 2) {
      let params3 = {
        photo: image1,
        cv: image2,
        description: craftmenData.description,
        address: address?.formatted_address,
        lat: address?.geometry?.location?.lat(),
        lng: address?.geometry?.location?.lng(),
      };

      // VALIDATE
      for (let key in params3) {
        if (params3[key] == "" || !params3[key]) {
          return toast.warn(`${key} can not be empty`);
        }
      }

      // because city can be empty
      params.city = city;

      // put step 1 in form
      for (let key in step1Params) {
        formData.append(key, step1Params[key]);
      }

      // put step 2 in form
      step2Form._skills.forEach((e) => formData.append("skills", e));
      formData.append("education", step2Form._education);
      formData.append("course", step2Form._course);
      step2Form._certificate.forEach((e) => formData.append("certificates", e));
      formData.append("experience", step2Form._experience);
      formData.append("school", step2Form._school);

      // put step 3 to form
      for (let key in params3) {
        formData.append(key, params3[key]);
      }

      // attach fcmToken
      formData.append("fcmToken", myFCMToken);

      const url = URL("general/signup");
      setIsApiCall(true);
      const response = await Post(url, formData, apiHeader(false, true));
      setIsApiCall(false);

      if (response !== undefined) {
        dispatch(saveLoginUserData(response?.data?.data));
        history.replace("/profile");
      } else {
        // step1
        formData.delete("role");
        formData.delete("userName");
        formData.delete("email");
        formData.delete("countryCode");
        formData.delete("contactNo");
        formData.delete("password");
        formData.delete("passwordConfirm");

        // step2
        formData.delete("skills");
        formData.delete("education");
        formData.delete("course");
        formData.delete("certificates");
        formData.delete("experience");
        formData.delete("school");

        // step 3
        formData.delete("photo");
        formData.delete("cv");
        formData.delete("description");
        formData.delete("address");
        formData.delete("lat");
        formData.delete("lng");
      }
    }
  };
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  // console.log(craftmenData);
  const dataSet1 = () => {
    return (
      <div className="step_form_main mt-5 ">
        <h4 className=" font-30">Create a JOBSTER Profile</h4>
        <Container>
          <Row className="mb-5">
            <Col md={6} className="cus_btn_profile1">
              <Button onClick={() => setActiveForm(0)}>Craft</Button>
              {activeForm == 0 && <Image src={green_tick} />}
            </Col>
            <Col md={6} className="cus_btn_profile2">
              <Button onClick={() => setActiveForm(1)}>Companies</Button>
              {activeForm == 1 && <Image src={blue_tick} />}
            </Col>
          </Row>
          <Col md={12} className="mb-3">
            <Form.Control
              type="text"
              placeholder="Full Name"
              required
              value={craftmenData.userName}
              name="userName"
              onChange={handleChange}
            />
          </Col>
          <Col md={12} className="mb-3">
            <Form.Control
              type="email"
              placeholder="Email Address"
              value={craftmenData.email}
              required
              name="email"
              onChange={handleChange}
            />
          </Col>
          <Col md={12} className="mb-3">
            <Form.Control
              type="email"
              required
              placeholder="Re-type Email Address"
              value={craftmenData.confirmEmail}
              onChange={handleChange}
              name="confirmEmail"
            />
          </Col>
          <Row>
            <div className="d-flex j-between">
              {/* Flag */}
              {/* <div className="step_form_col_three flag-container">

                <i className={`flag flag-${countryFlag}`}></i>
     
              </div> */}
              <div className="step_form_col_one">
                <FormControl variant="standard">
                  <Select
                    className="drop1_new"
                    labelId="demo-customized-select-label"
                    id="demo-customized-select"
                    value={craftmenData.countryCode}
                    placeholder="Code"
                    name="countryCode"
                    onChange={handleChange}
                    input={<BootstrapInput />}
                  >
                    <MenuItem disabled value="">
                      <em>Select Country Code</em>
                    </MenuItem>
                    {countryCode.map((item, i) => {
                      return (
                        <MenuItem key={i} value={item.dial_code}>
                          <i
                            className={`flag flag-${(item?.code).toLowerCase()}`}
                          ></i>
                          {item.dial_code}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              {/* <div className="step_form_col_one">
              <Select1
             
 
             getOptionLabel={option => option.value} 
             getOptionValue={option => option.value}
                onChange={craftmenData.countryCode}
                value={craftmenData.countryCode}

                options={ countryCode.map(t=>({value: t, label: t}))
              }
                className="basic-multi-select"
                classNamePrefix="select"
                name="countryCode"

              />
              </div> */}
              <div className="step_form_col_three">
                <FormControl variant="standard">
                  <Form.Control
                    type="number"
                    placeholder="Number"
                    defaultValue="value"
                    value={craftmenData.contactNo}
                    onChange={handleChange}
                    name="contactNo"
                  />
                </FormControl>
              </div>
            </div>
            <Col md={12} className=" mt-4">
              <Form.Label
                className="mb-3"
                style={{ fontSize: "22px", fontFamily: "sBold" }}
              >
                Set a Password
              </Form.Label>
              <Form.Control
                type="Password"
                placeholder="Password"
                onChange={handleChange}
                name="password"
                value={craftmenData.password}
              />
            </Col>
            <Col md={12} className=" mt-4 mb-3">
              <Form.Control
                type="Password"
                placeholder="Confirm Password"
                name="passwordConfirm"
                value={craftmenData.passwordConfirm}
                onChange={handleChange}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  };
  const setSelectHandler = (
    data,
    customArray,
    setterCustomArray,
    setter,
    fieldName
  ) => {
    if (data.length > customArray.length) {
      let oldData = customArray.slice();
      oldData.push(data[data.length - 1][fieldName]);
      setterCustomArray(oldData);
    } else {
      let newArray = [];
      data.length > 0 &&
        data.map((item) => {
          newArray.push(item[fieldName]);
        });
      setterCustomArray(newArray);
    }
    setter(data);
  };

  // educationField.map((item) => {
  //   educationFieldArray.push(item.education);
  // });
  // courseField.map((item) => {
  //   courseFieldArray.push(item.course);
  // });
  // certificatesField.map((item) => {
  //   certificatesFieldArray.push(item.jobCertificate);
  // });
  // experienceField.map((item) => {
  //   experienceFieldArray.push(item.experience);
  // });

  const dataSet2 = () => {
    return (
      <div className="step_form_main mt-5">
        <h3 className="text-center">Student Details</h3>
        <p className="text-center">Please fill in the details below.</p>

        <Container>
          <Row>
            <Col md={12} className="mb-3">
              <label className="mb-2 p-18 gray">Your Skills</label>
              <Select1
                isMulti
                name="colors"
                getOptionLabel={(option) => option.skill}
                getOptionValue={(option) => option.skill}
                onChange={(data) => {
                  setSelectHandler(
                    data,
                    skillArray,
                    setSkillArray,
                    setSkillsField,
                    "skill"
                  );
                }}
                value={skillsField}
                options={skills}
                className="basic-multi-select"
                classNamePrefix="select"
              />
            </Col>
            <Col md={12} className="mb-3">
              <label className="mb-2 p-18 gray">Education</label>
              <Select1
                name="colors"
                getOptionLabel={(option) => option.educations}
                getOptionValue={(option) => option.educations}
                onChange={(data) => {
                  setSelectHandler(
                    data,
                    educationFieldArray,
                    setEducationFieldArray,
                    setEducationField,
                    "education"
                  );
                }}
                options={educationNewArray}
                value={educationField}
                className="basic-multi-select"
                classNamePrefix="select"
              />
            </Col>
            <Col md={12} className="mb-3">
              <label className="mb-2 p-18 gray">Course</label>
              <Select1
                name="colors"
                getOptionLabel={(option) => option.courses}
                getOptionValue={(option) => option.courses}
                onChange={(data) => {
                  setSelectHandler(
                    data,
                    courseFieldArray,
                    setCourseFieldArray,
                    setCourseField,
                    "course"
                  );
                }}
                value={courseField}
                options={coursesNewArray}
                className="basic-multi-select"
                classNamePrefix="select"
              />
            </Col>
            <Col md={12} className="mb-3">
              <label className="mb-2 p-18 gray">School</label>

              <Form.Control
                type="text"
                placeholder="School"
                required
                value={craftmenData.school}
                name="school"
                onChange={handleChange}
              />
            </Col>
            <Col md={12} className="mb-3">
              <label className="mb-2 p-18 gray">Certificates</label>
              <Select1
                isMulti
                getOptionLabel={(option) => option.jobCertificate}
                getOptionValue={(option) => option.jobCertificate}
                onChange={(data) => {
                  setSelectHandler(
                    data,
                    certificatesFieldArray,
                    setCertificatesFieldArray,
                    setCertificatesField,
                    "jobCertificate"
                  );
                }}
                value={certificatesField}
                options={certificate}
                className="basic-multi-select"
                classNamePrefix="select"
              />
            </Col>
            <Col md={12} className="mb-3">
              <label className="mb-2 p-18 gray">Experience</label>
              <Select1
                defaultValue="test"
                // onChange={setExperienceField}
                options={experienceNewArray}
                value={experienceField}
                getOptionLabel={(option) => option.experience}
                getOptionValue={(option) => option.experience}
                onChange={(data) => {
                  setSelectHandler(
                    data,
                    experienceFieldArray,
                    setExperienceFieldArray,
                    setExperienceField,
                    "experience"
                  );
                }}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Choose Any One"
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  };
  const dataSet3 = () => {
    return (
      <div className="step_form_main mt-5">
        <h3 className="text-center">Craftman Details</h3>
        <p className="text-center">Please fill in the details below.</p>

        <Container>
          <Row>
            <Col md={12} className="mb-3">
              <label class="step_form_3rd_fileupload ">
                {image1 ? image1.name : "Profile Image"}

                <div className="innerDiv_fileUpload w-200">
                  <div className="d-flex j-center a-center upload_btn c-p">
                    <Image src={upload_icon} />
                    <span style={{ margin: 0, marginLeft: 10 }}>
                      Attach Your Image
                    </span>
                  </div>
                </div>
                <input
                  type="file"
                  size="2000000"
                  class="file_upload_form3rd"
                  name="image1"
                  onChange={(e) => {
                    if (e.target.files?.length > 0) {
                      if (
                        !["image/jpeg", "image/png", "image/jpg"].includes(
                          e.target.files[0].type
                        )
                      ) {
                        return toast.error(
                          "Please upload a valid image. [jpg and png formats only]"
                        );
                      }

                      setImage1(e.target.files[0]);
                    }
                  }}
                />
              </label>
            </Col>
            <Col md={12} className="mb-3">
              <label class="step_form_3rd_fileupload ">
                {image2 ? image2.name : "Upload CV"}
                <div className="innerDiv_fileUpload ">
                  <div className="d-flex j-center a-center upload_btn attach-cv-btn c-p">
                    <Image src={upload_icon} />
                    <span style={{ margin: 0, marginLeft: 10 }}>
                      Attach CV{" "}
                    </span>
                  </div>
                </div>
                <input
                  type="file"
                  size="2000000"
                  class="file_upload_form3rd"
                  name="image2"
                  onChange={(e) => {
                    if (e.target.files?.length > 0) {
                      if (
                        !["application/pdf"].includes(e.target.files[0].type)
                      ) {
                        return toast.error(
                          "Please upload a valid CV [only pdf is allowed]"
                        );
                      }

                      setImage2(e.target.files[0]);
                    }
                  }}
                />
              </label>
            </Col>
            <Col md={12} className="mb-3">
              {/* <Form.Control type="text" placeholder="Location" /> */}
              <div className="new_loc_css">
                <LocationInput setPlace={setAddress} />
              </div>
            </Col>

            <Col md={12} className="mb-3">
              <Form.Control
                as="textarea"
                rows={5}
                placeholder="About Me"
                onChange={handleChange}
                name="description"
                value={craftmenData.description}
              />
            </Col>
          </Row>
        </Container>
      </div>
    );
  };

  const getStepContent = (activeStep) => {
    switch (activeStep) {
      case 0:
        return dataSet1();
      case 1:
        return dataSet2();
      case 2:
        return dataSet3();

      default:
        return "unknown step";
    }
  };

  return (
    <>
      <FormProvider>
        {activeForm == 0 && (
          <div
            className={
              activeStep == 0
                ? "craftmen_signup2"
                : null
                ? activeStep == 1
                : "craftmen_signup2 "
            }
          >
            <Container className="container_733 form_mid ">
              <Stack sx={{ width: "100%" }} spacing={4}>
                <Stepper
                  alternativeLabel
                  activeStep={activeStep}
                  connector={<QontoConnector />}
                >
                  {steps.map((label, index) => {
                    return (
                      <Step key={label}>
                        <StepLabel></StepLabel>
                      </Step>
                    );
                  })}
                </Stepper>
              </Stack>
              <form
                className="step_form_1st"
                onSubmit={(e) => {
                  e.preventDefault();
                  handleNext();
                }}
              >
                {getStepContent(activeStep)}

                <Container>
                  <Row>
                    <Col md={activeStep < 1 ? 12 : 6}>
                      {activeStep != 0 && (
                        <Button
                          className="step_form_btn_next "
                          variant="contained"
                          color="primary"
                          onClick={handleBack}
                          disabled={activeStep == 0 || isApiCall}
                        >
                          Back
                        </Button>
                      )}
                    </Col>

                    {activeStep == steps.length - 1 && (
                      <Col md={activeStep == 2 ? 6 : 12}>
                        <Button
                          className="step_form_btn_next"
                          variant="contained"
                          color="primary"
                          onClick={(e) => {
                            e.preventDefault();
                            handleNext();
                          }}
                          disabled={isApiCall}
                          type="submit"
                        >
                          {isApiCall ? "Please wait..." : "Create Account"}
                        </Button>
                      </Col>
                    )}
                    <Col md={activeStep < 1 ? 12 : 6}>
                      {activeStep == 0 || activeStep == steps.length - 2 ? (
                        <Button
                          className="step_form_btn_next"
                          variant="contained"
                          color="primary"
                          onClick={(e) => {
                            e.preventDefault();
                            handleNext();
                          }}
                          disabled={isApiCall}
                        >
                          {isApiCall ? "Please wait..." : "Next"}
                        </Button>
                      ) : null}
                    </Col>

                    {/* <p className="mt-4 text-center">
                      Already have an account? Sign In
                    </p> */}
                    <Col
                      md={12}
                      className="mb-3 mt-3 text-center alreadyAccountContainer"
                    >
                      <p>Already have an account? </p>
                      <Link to="/signin">Sign In</Link>
                    </Col>
                  </Row>
                </Container>
              </form>
            </Container>
          </div>
        )}

        {/* Company */}
        {activeForm == 1 && (
          <CompanySignup
            companyData={companyData}
            handleChangeCompany={handleChangeCompany}
            setCompanyData={setCompanyData}
            setActiveForm={setActiveForm}
            activeForm={activeForm}
            handleSubmitCompany={handleSubmitCompany}
            isApiCall={isApiCall}
          />
        )}
      </FormProvider>
    </>
  );
};

export default ProfileStepForm;
